import { render } from "./ToDoListPage.vue?vue&type=template&id=408e0a8a&ts=true"
import script from "./ToDoListPage.vue?vue&type=script&lang=ts"
export * from "./ToDoListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__